import _extends from 'babel-runtime/helpers/extends';
import _Object$keys from 'babel-runtime/core-js/object/keys';

import { filedGetFieldAPI } from '@/api/crm/common';
import { crmLeadsSaveAPI } from '@/api/crm/leads';

import XrCreate from '@/components/XrCreate';
import CreateSections from '@/components/CreateSections';
import WkFormItems from '@/components/NewCom/WkForm/WkFormItems';

import CustomFieldsMixin from '@/mixins/CustomFields';
import { isEmpty } from '@/utils/types';

export default {
  // 新建编辑
  name: 'LeadsCreate',

  components: {
    XrCreate: XrCreate,
    CreateSections: CreateSections,
    WkFormItems: WkFormItems
  },

  mixins: [CustomFieldsMixin],

  props: {
    phone: String,
    action: {
      type: Object,
      default: function _default() {
        return {
          type: 'save',
          id: '',
          data: {}
        };
      }
    }
  },

  data: function data() {
    return {
      loading: false,
      baseFields: [],
      fieldList: [],
      fieldForm: {},
      fieldRules: {}
    };
  },


  computed: {
    title: function title() {
      return this.action.type === 'update' ? '编辑线索' : '新建线索';
    }
  },

  watch: {},

  created: function created() {
    this.getField();
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},


  methods: {
    /**
     * 获取数据
     */
    getField: function getField() {
      var _this = this;

      this.loading = true;
      var params = {
        types: 'crm_leads',
        module: 'crm',
        controller: 'leads',
        action: this.action.type,
        format: 2
      };

      if (this.action.type == 'update') {
        params.action_id = this.action.id;
      }

      filedGetFieldAPI(params).then(function (res) {
        var list = res.data || [];
        if (!isEmpty(_this.phone)) {
          list.forEach(function (item) {
            if (item.form_type === 'mobile') {
              item.default_value = _this.phone;
            }
          });
        }
        var assistIds = _this.getFormAssistIds(list);
        var baseFields = [];

        var fieldList = [];
        var fieldRules = {};
        var fieldForm = {};
        list.forEach(function (children) {
          var fields = [];
          children.forEach(function (item) {
            var temp = _this.getFormItemDefaultProperty(item);
            temp.show = !assistIds.includes(item.formAssistId);

            var canEdit = _this.getItemIsCanEdit(item, _this.action.type);
            // 是否能编辑权限
            if (temp.show && canEdit) {
              fieldRules[temp.field] = _this.getRules(item);
            }

            // 是否可编辑
            temp.disabled = !canEdit;

            // 特殊字段允许多选
            _this.getItemRadio(item, temp);

            // 获取默认值
            if (temp.show) {
              fieldForm[temp.field] = _this.getItemValue(item, _this.action.data, _this.action.type);
            }
            fields.push(temp);
            baseFields.push(item);
          });
          fieldList.push(fields);
        });

        _this.baseFields = baseFields;
        _this.fieldList = fieldList;
        _this.fieldForm = fieldForm;
        _this.fieldRules = fieldRules;

        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },


    /**
     * 保存
     */
    saveClick: function saveClick() {
      var _this2 = this;

      this.loading = true;
      var crmForm = this.$refs.crmForm;
      crmForm.validate(function (valid) {
        if (valid) {
          var params = _this2.getSubmiteParams(_this2.baseFields, _this2.fieldForm);
          if (_this2.action.type === 'update') {
            params.id = _this2.action.id;
          }
          console.log(params);
          _this2.submiteParams(params);
        } else {
          _this2.loading = false;
          // 提示第一个error
          _this2.getFormErrorMessage(crmForm);
          return false;
        }
      });
    },


    /**
     * 提交上传
     */
    submiteParams: function submiteParams(params) {
      var _this3 = this;

      if (this.action.type == 'update') {
        params.action_id = this.action.id;
        // params.entity.batchId = this.action.batchId
      }

      // 相关添加时候的多余提交信息
      if (this.action.relativeData && _Object$keys(this.action.relativeData).length) {
        params = _extends({}, params, this.action.relativeData);
      }
      crmLeadsSaveAPI(params).then(function (res) {
        _this3.loading = false;
        _this3.$message.success(_this3.action.type == 'update' ? '编辑成功' : '添加成功');

        _this3.close();

        // 保存成功
        _this3.$emit('save-success', {
          type: 'leads'
        });
      }).catch(function () {
        _this3.loading = false;
      });
    },


    /**
     * 验证唯一
     */
    UniquePromise: function UniquePromise(_ref) {
      var field = _ref.field,
          value = _ref.value;

      return this.getUniquePromise(field, value, this.action);
    },


    /**
     * change
     */
    formChange: function formChange(field, index, value, valueList) {
      if (['select', 'checkbox'].includes(field.form_type) && field.remark === 'options_type' && field.optionsData) {
        var _getFormContentByOpti = this.getFormContentByOptionsChange(this.fieldList, this.fieldForm),
            fieldForm = _getFormContentByOpti.fieldForm,
            fieldRules = _getFormContentByOpti.fieldRules;

        this.fieldForm = fieldForm;
        this.fieldRules = fieldRules;
      }
    },


    /**
     * 地址change
     */
    otherChange: function otherChange(data, field) {
      this.$set(this.fieldForm, field.field, data.value);
      this.$refs.crmForm.validateField(field.field);
    },


    /**
     * 关闭
     */
    close: function close() {
      this.$emit('close');
    }
  }
};